import { formatPrice } from '../utils';
const addOrderInfo = () => {
    const prodPage = document.querySelector('.product-page');
    if (!prodPage) {
        return true;
    }
    ;
    const input = document.querySelector('textarea[name="data[new][order_info_field]"]');
    const art = document.querySelector('.product-page__art');
    const name = document.querySelector('.product-page__name span');
    const price = document.querySelector('.product-page__actual-price');
    console.log({ input, art, name, price });
    if (!input && !art && !name && !price) {
        return true;
    }
    ;
    const formatetdPrise = formatPrice(price.dataset.price);
    let text = `${art && art.innerHTML} ${name.innerHTML} – ${formatetdPrise} руб.`;
    let summery = parseInt(price.dataset.price);
    const props = document.querySelector('.product-page__props');
    if (props) {
        const options = props.querySelectorAll('input');
        options && options.forEach(option => {
            if (option.checked) {
                const format = formatPrice(option.dataset.price);
                summery += parseInt(option.dataset.price);
                text = `${text}\n${option.dataset.name} – ${format} руб.`;
            }
        });
    }
    const formatSummery = formatPrice(summery.toString());
    text = `${text}\nИтого: ${formatSummery} руб.`;
    input && (input.value = text);
};
export default addOrderInfo;
